import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcTranslation} from 'exc-core';
import {KanbanItemAction} from '../../kanban-item/kanban-item.component';

@Component({
  selector: 'comment-waffle',
  templateUrl: './comment-waffle.component.html',
  styles: []
})
export class CommentWaffleComponent extends ExcTranslation implements OnInit {
  @Input('Comment') Comment;
  @Input('Title') Title;
  @Input('CanEdit') CanEdit = false;
  @Output() OnEdit: EventEmitter<any> = new EventEmitter<any>();

  constructor(private excDss: DefaultSettingsService) {
    super();
  }
  emitEdit() {
    if (this.OnEdit) {
      this.OnEdit.emit();
    }
  }

  ngOnInit() {
  }

}
